export const PERSONAL_THRESHOLDS = [
  { max: 0.80, bg: 'bg-brand-green', hex: '#12B76A', label: 'Normal' },
  { max: 1.00, bg: 'bg-brand-red', hex: '#F04438', label: 'Low Capacity' },
] as const

export const OVERFLOW_THRESHOLDS = [
  { max: 0.80, bg: 'bg-brand-green', hex: '#12B76A', label: 'Normal' },
  { max: 1.00, bg: 'bg-brand-red', hex: '#F04438', label: 'Exhausting' },
] as const

export const SOFT_CAP_PERCENTAGE = 0.95
export const POLL_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes
export const RESET_HOUR_UTC = 0 // 00:00 UTC = 04:00 GST
